// Legacy BPM Topography engine, moved as-is from public/javascripts/_d3/pmap-topography.js.
// Feeds on the module-scoped d3 v3 (surface3D patch included) — the svg selection passed
// into the constructor MUST come from the same `d3v3` instance, never npm d3 v7.
// Only strict-mode fixes applied; the export replaces the old `window.PMapTopography` global.
import d3 from '@aytm/app/stats/components/topography/d3v3'
import '@aytm/app/stats/components/topography/surface3d'

var exported = {}

;(function (g) {
  var PITCH_MAX = 0.5
  var PITCH_MIN = 0
  var DEFAULT_PITCH = 0.4
  var DEFAULT_YAW = 1
  var DEFAULT_ZOOM = 1

  var BACKGROUND_COLOR = '#111619'
  var COLOR_GRADIENT_HEIGHTS = [-70, 70]
  var COLOR_GRADIENT = [
    { h: 225, s: 1, l: 0.3, p: 0 },
    { h: 215, s: 0.9, l: 0.5, p: 0.11 },
    { h: 200, s: 0.8, l: 0.6, p: 0.22 },
    { h: 135, s: 0.6, l: 0.55, p: 0.33 },
    { h: 115, s: 0.6, l: 0.55, p: 0.33 },
    { h: 75, s: 0.7, l: 0.55, p: 0.44 },
    { h: 50, s: 0.9, l: 0.55, p: 0.55 },
    { h: 35, s: 0.8, l: 0.55, p: 0.66 },
    { h: 25, s: 0.9, l: 0.5, p: 0.77 },
    { h: 10, s: 0.9, l: 0.5, p: 0.9 },
    { h: 0, s: 0.9, l: 0.35, p: 1 }
  ]
  var COLOR_FADE = [-0.05, 0.3]

  function PMapTopography(args) {
    if (this instanceof PMapTopography) {
      var _args = args || {}
      this.svg = _args.svg
      this.data = _args.data
      this.pins = _args.pins || []
      this.flags = _args.flags || []
      this.legend = _args.legend
      this.version = _args.version || 1
      this.yaw = DEFAULT_YAW
      this.pitch = DEFAULT_PITCH
      this.zoom = DEFAULT_ZOOM
      this.drag = false
      this.resize(_args)
      this.initControls(_args)
    } else {
      return new PMapTopography(args)
    }
  }

  PMapTopography.prototype.resize = function (args) {
    var _args = args || {}
    _args.width || (_args.width = this.svg ? parseInt(this.svg.style('width'), 10) : 658)
    _args.height || (_args.height = this.svg ? parseInt(this.svg.style('height'), 10) : 426)
    this.width = _args.width
    this.height = _args.height
    this.render(_args)
    return this
  }

  PMapTopography.prototype.render = function (args) {
    if (null == this.svg) return
    var _args = args || {}
    // this.svg.style('background',BACKGROUND_COLOR);
    this.svg.attr('width', this.width)
    this.svg.attr('height', this.height)
    this.svg.attr('viewbox', '0 0 ' + this.width + ' ' + this.height)
    var node = this.svg.node()
    if (node != undefined && null != node) node.style.display = 'inline'
    var bgRect = (this.bgRect = this.svg.select('rect.pmap-topography-bg'))
    if (bgRect.empty())
      bgRect = this.bgRect = this.svg
        .append('rect')
        .attr('class', 'pmap-topography-bg')
        .attr('fill', BACKGROUND_COLOR)
        .attr('stroke', BACKGROUND_COLOR)
        .attr('x', 0)
        .attr('y', 0)
    bgRect.attr('width', this.width).attr('height', this.height)
    if (null != this.data) {
      var colorScales = {
        fill: null,
        stroke: null
      }
      var colorFunction = function (height, minHeight, maxHeight, depth, minDepth, maxDepth, scalesCache) {
        scalesCache || (scalesCache = colorScales)
        scalesCache.fill ||
          (function () {
            var domain = []
            var hrange = []
            var srange = []
            var lrange = []
            // var heightDiff = maxHeight - minHeight;
            for (var i = 0; i < COLOR_GRADIENT.length; i++) {
              var g = COLOR_GRADIENT[i]
              // domain.push(minHeight+heightDiff*g.p);
              domain.push(COLOR_GRADIENT_HEIGHTS[0] + (COLOR_GRADIENT_HEIGHTS[1] - COLOR_GRADIENT_HEIGHTS[0]) * g.p)
              hrange.push(g.h)
              srange.push(g.s)
              lrange.push(g.l)
            }
            scalesCache.fill = {
              h: d3.scale.linear().domain(domain).range(hrange).clamp(true),
              s: d3.scale.linear().domain(domain).range(srange).clamp(true),
              l: d3.scale.linear().domain(domain).range(lrange).clamp(true),
              f: d3.scale.linear().domain([minDepth, maxDepth]).range(COLOR_FADE).clamp(true)
            }
          })()
        var c = d3
          .hsl(
            scalesCache.fill.h(height),
            scalesCache.fill.s(height),
            Math.max(0, scalesCache.fill.l(height) - scalesCache.fill.f(depth))
          )
          .rgb()
        return 'rgb(' + parseInt(c.r, 10) + ',' + parseInt(c.g, 10) + ',' + parseInt(c.b, 10) + ')'
      }
      var strokeColorFunction = function (height, minHeight, maxHeight, depth, minDepth, maxDepth, scalesCache) {
        scalesCache || (scalesCache = colorScales)
        scalesCache.stroke ||
          (function () {
            var domain = []
            var hrange = []
            var srange = []
            var lrange = []
            // var heightDiff = maxHeight - minHeight;
            for (var i = 0; i < COLOR_GRADIENT.length; i++) {
              var g = COLOR_GRADIENT[i]
              // domain.push(minHeight+heightDiff*g.p);
              domain.push(-70 + 140 * g.p)
              hrange.push(g.h)
              srange.push(g.s)
              lrange.push(g.l)
            }
            scalesCache.stroke = {
              h: d3.scale.linear().domain(domain).range(hrange).clamp(true),
              s: d3.scale.linear().domain(domain).range(srange).clamp(true),
              l: d3.scale.linear().domain(domain).range(lrange).clamp(true),
              f: d3.scale.linear().domain([minDepth, maxDepth]).range(COLOR_FADE).clamp(true)
            }
          })()
        var c = d3
          .hsl(
            scalesCache.stroke.h(height),
            scalesCache.stroke.s(height),
            Math.max(0, Math.min(1, scalesCache.stroke.l(height) - scalesCache.stroke.f(depth) + 0.04))
          )
          .rgb()
        return 'rgb(' + parseInt(c.r) + ',' + parseInt(c.g) + ',' + parseInt(c.b) + ')'
      }
      this.surface ||
        function () {
          this.surface = this.svg.append('g')
          this.surface
            .attr('class', 'pmap-topography-surface3d')
            .attr('stroke', '#656565')
            .attr('stroke-width', 1)
            .attr('stroke-opacity', 1)
            .attr('fill-opacity', 1)
        }.apply(this)
      this.surface.selectAll('*').remove()
      if (this.surfaceRender) {
        this.surfaceRender
          .data([this.data])
          .surface3D()
          .surfaceColor(colorFunction)
          .strokeColor(strokeColorFunction)
          .pins(this.pins)
          .flags(this.flags)
          .zoom(this.zoom)
      } else {
        this.surfaceRender = this.surface
          .data([this.data])
          .surface3D(this.width, this.height)
          .setCenter(this.width / 2, this.height * 0.65)
          .pins(this.pins)
          .flags(this.flags)
          .surfaceColor(colorFunction)
          .strokeColor(strokeColorFunction)
      }
      this.surfaceRender.turntable(this.yaw, this.pitch)
      var legendG = (this.legendG = this.svg.select('g.pmap-topography-legend'))
      if (legendG.empty()) legendG = this.legendG = this.svg.append('g').attr('class', 'pmap-topography-legend')
      legendG.attr('transform', 'translate(0,' + (this.height - 30) + ')')
      var legendTitleText = null != this.legend && null != this.legend.title ? this.legend.title : null
      var legendTitle = legendG.select('text.pmap-topography-legend-title')
      if (legendTitleText) {
        if (legendTitle.empty()) {
          legendTitle = legendG
            .append('text')
            .attr('class', 'pmap-topography-legend-title')
            .attr('fill', '#CCCCCC')
            .attr('stroke', 'none')
            .attr('x', 10)
            .attr('y', 20)
          legendTitle
            .append('tspan')
            .attr('class', 'pmap-topography-legend-title-prefix')
            .text('Elevation: ')
            .attr('style', 'font-weight:bold')
          legendTitle.append('tspan').attr('class', 'pmap-topography-legend-title-text')
        }
        legendTitle.select('tspan.pmap-topography-legend-title-text').text(legendTitleText)
        if (this.version >= 3) {
          legendTitle.selectAll('a').remove()
          legendTitle
            .append('a')
            .attr({ 'xlink:href': '#' })
            .on('mousedown', function () {
              window.open('https://helpcenter.aytm.com/hc/en-us/articles/360049242171')
              // d3.select(this)
              //   .attr({"xlink:href": });
            })
            .attr('fill', '#429ff0')
            .text(' [wiki]')
        }
      } else {
        legendTitle.remove()
        legendTitle = null
      }
      var legendMin = parseFloat(null != this.legend && null != this.legend.min ? this.legend.min : 'NaN')
      var legendMax = parseFloat(null != this.legend && null != this.legend.max ? this.legend.max : 'NaN')
      var legendMaxLabel = legendG.select('text.pmap-topography-legend-max')
      if (!isNaN(legendMax)) {
        if (legendMaxLabel.empty())
          legendMaxLabel = legendG
            .append('text')
            .attr('fill', '#CCCCCC')
            .attr('stroke', 'none')
            .attr('class', 'pmap-topography-legend-max')
            .attr('text-anchor', 'start')
        legendMaxLabel
          .text(legendMax.toFixed(1))
          .attr('x', this.width - 53)
          .attr('y', 20)
      } else {
        legendMaxLabel.remove()
        legendMaxLabel = null
      }
      var bricksLength = null != this.legend && null != this.legend.bricks ? this.legend.bricks.length : 0
      var bricksG = legendG.select('g.pmap-topography-legend-bricks')
      if (bricksLength > 0) {
        if (bricksG.empty()) bricksG = legendG.append('g').attr('class', 'pmap-topography-legend-bricks')
        bricksG.attr('transform', 'translate(' + (this.width - 60 - bricksLength * (15 + 3)) + ',13)')
        var bricks = bricksG.selectAll('rect').data(this.legend.bricks)
        bricks.enter().append('rect').attr('width', 15).attr('height', 6).attr('y', 0)
        bricks.exit().remove()
        var colorScalesCache = {}
        bricks
          .attr('x', function (d, i) {
            return i * (15 + 3)
          })
          .attr('fill', function (d, i) {
            return colorFunction(
              d,
              isNaN(legendMin) ? legendMin : COLOR_GRADIENT_HEIGHTS[0],
              isNaN(legendMax) ? legendMax : COLOR_GRADIENT_HEIGHTS[1],
              0,
              0,
              1,
              colorScalesCache
            )
          })
          .attr('stroke', function (d, i) {
            return strokeColorFunction(
              d,
              isNaN(legendMin) ? legendMin : COLOR_GRADIENT_HEIGHTS[0],
              isNaN(legendMax) ? legendMax : COLOR_GRADIENT_HEIGHTS[1],
              0,
              0,
              1,
              colorScalesCache
            )
          })
      } else {
        bricksG.remove()
        bricksG = null
      }
      var legendMinLabel = legendG.select('text.pmap-topography-legend-min')
      if (!isNaN(legendMin) && bricksLength > 0) {
        if (legendMinLabel.empty())
          legendMinLabel = legendG
            .append('text')
            .attr('fill', '#CCCCCC')
            .attr('stroke', 'none')
            .attr('class', 'pmap-topography-legend-min')
            .attr('text-anchor', 'end')
        legendMinLabel
          .text(legendMin.toFixed(1))
          .attr('x', this.width - 60 - bricksLength * (15 + 3) - 10)
          .attr('y', 20)
      } else {
        legendMinLabel.remove()
        legendMinLabel = null
      }
      var legendBG = legendG.select('rect.pmap-topography-legend-bg')
      if (legendTitle || !isNaN(legendMin) || !isNaN(legendMax) || bricksLength > 0) {
        if (legendBG.empty())
          legendBG = legendG
            .insert('rect', ':first-child')
            .attr('class', 'pmap-topography-legend-bg')
            .attr('y', 0)
            .attr('stroke', 'none')
            .attr('fill', 'rgba(30,30,30,.5)')
            .attr('height', 36)
        legendBG.attr('x', 0).attr('width', this.width)
      } else {
        legendBG.remove()
        legendBG = null
      }
    }

    return this
  }

  PMapTopography.prototype.setData = function (data, redraw) {
    this.data = data
    this.zoom = DEFAULT_ZOOM
    this.yaw = DEFAULT_YAW
    this.pitch = DEFAULT_PITCH
    if (redraw) this.render()
    return this
  }

  PMapTopography.prototype.setPins = function (pins, redraw) {
    this.pins = pins
    if (redraw) this.render()
    return this
  }

  PMapTopography.prototype.setFlags = function (flags, redraw) {
    this.flags = flags
    if (redraw) this.render()
    return this
  }

  PMapTopography.prototype.setLegend = function (legend, redraw) {
    if (false === legend) {
      this.legend = {}
    } else if (null != legend) {
      for (var l in legend) {
        this.legend[l] = legend[l]
      }
    }
    if (redraw) this.render()
    return this
  }

  PMapTopography.prototype.resetView = function () {
    this.zoom = DEFAULT_ZOOM
    this.pitch = DEFAULT_PITCH
    this.yaw = DEFAULT_YAW
    if (this.surfaceRender) {
      this.surfaceRender.turntable(this.yaw, this.pitch)
      this.surfaceRender.zoom(this.zoom)
    }
  }

  PMapTopography.prototype.animateRotation = function (rotate, delta, frameSize) {
    rotate || (rotate = !this.animateRotationInterval)
    delta || (delta = 0.005)
    frameSize || (frameSize = 17)
    if (!rotate) {
      if (null != this.animateRotationInterval) {
        clearInterval(this.animateRotationInterval)
        this.animateRotationInterval = null
      }
    } else {
      var _this = this
      this.animateRotationInterval = setInterval(function () {
        _this.yaw += delta
        if (_this.surfaceRender) _this.surfaceRender.turntable(_this.yaw, _this.pitch)
      }, frameSize)
    }
  }

  PMapTopography.prototype.initControls = function (args) {
    if (null == this.svg) return
    var _this = this
    this.svg
      .on('mousedown', function () {
        d3.event.preventDefault()
        _this.drag = [d3.mouse(this), _this.yaw, _this.pitch]
        return false
      })
      .on('mouseup', function () {
        d3.event.preventDefault()
        _this.drag = false
        if (1 == d3.event.button) {
          if (d3.event.shiftKey) _this.animateRotation()
          else _this.resetView()
        } else if (0 == d3.event.button && d3.event.shiftKey) {
          _this.animateRotation()
        }
        return false
      })
      .on('mousemove', function () {
        d3.event.preventDefault()
        if (_this.drag) {
          var mouse = d3.mouse(this)
          _this.yaw = _this.drag[1] - (mouse[0] - _this.drag[0][0]) / ((_this.width || 800) / 5)
          _this.pitch = _this.drag[2] + (mouse[1] - _this.drag[0][1]) / ((_this.height || 600) / 2.5)
          _this.pitch = Math.max(PITCH_MIN, Math.min(PITCH_MAX, _this.pitch))
          if (_this.surfaceRender) _this.surfaceRender.turntable(_this.yaw, _this.pitch)
        }
        return false
      })
      .on('wheel', function () {
        d3.event.preventDefault()
        var zoomGain = -(parseInt(d3.event.deltaY, 10) || 100) / 1000
        zoomGain = Math.min(1, Math.max(-1, zoomGain))
        _this.zoom = _this.zoom + zoomGain
        _this.zoom = Math.min(1.4, Math.max(0.5, _this.zoom))
        if (_this.surfaceRender) _this.surfaceRender.zoom(_this.zoom)
        return false
      })
    return this
  }

  g.PMapTopography = PMapTopography
})(exported)

export default exported.PMapTopography
